<template>
  <el-dialog
    title="用户管理窗口"
    :visible.sync="visible"
    @close="close">

    <el-form :inline="true" :model="UserMgEditForm" label-position="right">
      <el-form-item  label="ID" >
        <el-input v-model="UserMgEditForm.id" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="高能所用户ID">
        <el-input v-model="UserMgEditForm.umtId" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="UserMgEditForm.truename" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="cst网ID">
        <el-input v-model="UserMgEditForm.cstnetId" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-input v-model="UserMgEditForm.type" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="用户邮件地址">
        <el-input v-model="UserMgEditForm.useremail" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="是否管理员">
        <el-select style="width:200px;" v-model="UserMgEditForm.isadmin"  filterable placeholder="是否管理员 0否 1数据管理员 2系统管理员">
          <el-option
              v-for="item in isadmin_list"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户电话">
        <el-input v-model="UserMgEditForm.userphone" autocomplete="off" style="width:240px;" ></el-input>
      </el-form-item>
      <el-form-item label="用户单位">
        <el-input v-model="UserMgEditForm.usercp" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="用户邮件地址">
        <el-input v-model="UserMgEditForm.useremail" autocomplete="off" style="width:240px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="用户职位">
        <el-select style="width:200px;" v-model="UserMgEditForm.userposition"  
                   filterable placeholder="用户职位(学生，核心科学工作组成员，非核心科学工作组成员)">
          <el-option
              v-for="item in userposition_list"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>    
      <el-form-item label="备注">
        <el-input v-model="UserMgEditForm.remarks" autocomplete="off" style="width:240px;" ></el-input>
      </el-form-item>          
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {IsAdmin,UserPositionzh} from '../common';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      UserMgEditForm: {
        id:'',
        umtId: '',
        truename: '',
        cstnetId: '',
        type: '',
        passwordType: '',
        cstnetIdStatus: '',
        useremail: '',
        isadmin: '',
        userphone: '',
        usercp: '',
        userposition: '',
        tutorname: '',
        tutoremail: '',
        create_date: '',
        update_date: '',
        remarks: '',
        del_flag: '',
      },
      visible: false,
      isadmin_list:IsAdmin,
      userposition_list:UserPositionzh,

    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.UserMgEditForm.id = data.id;
      this.UserMgEditForm.umtId = data.umtId;
      this.UserMgEditForm.truename = data.truename;
      this.UserMgEditForm.cstnetId = data.cstnetId;
      this.UserMgEditForm.type = data.type;
      this.UserMgEditForm.passwordType = data.passwordType;
      this.UserMgEditForm.cstnetIdStatus = data.cstnetIdStatus;
      this.UserMgEditForm.useremail = data.useremail;
      this.UserMgEditForm.isadmin = data.isadmin;
      this.UserMgEditForm.userphone = data.userphone;
      this.UserMgEditForm.usercp = data.usercp;
      this.UserMgEditForm.userposition = data.userposition;
      this.UserMgEditForm.tutorname = data.tutorname;
      this.UserMgEditForm.tutoremail = data.tutoremail;
      this.UserMgEditForm.create_date = data.create_date;
      this.UserMgEditForm.update_date = data.update_date;
      this.UserMgEditForm.remarks = data.remarks;
      this.UserMgEditForm.del_flag = data.del_flag;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.UserMgEditForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
